
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        misTramites: [],
        tramitePendiente: {},
        hayModPendiente: false,
        hayPlanPagoPendiente: false,
    },
    getters: {
        hayModPendiente(state) {
            return state.hayModPendiente
        },
        hayPlanPagoPendiente(state) {
            return state.hayPlanPagoPendiente
        },
        misTramites(state) {
            return state.misTramites
        },
    },
    mutations: {
        setListaTramites(state, payload) {
            state.misTramites = payload
            state.hayPlanPagoPendiente = state.misTramites.find(tramite => tramite.estado == "EN CURSO" && tramite.tipo == "Plan de Pagos") ? true : false
            state.hayModPendiente = state.misTramites.find(tramite => tramite.estado == "EN CURSO" && tramite.tipo == "Modificación de datos") ? true : false
        }
    },
    actions: {
        // Obtengo listado de tramite del afiliado
        //07-10-24
        //getTramites se cambio a post
        async getTramites({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/misTramites',
                withCredentials: false,
                data: { nroafi: sessionStorage.getItem('nroafi') },
                headers: {
                    "Content-Type": "application/json",
                }
            }).then((response) => {
                const res = response.data.misTramites
                commit('setListaTramites', res)
            }).catch(function (error) {
                console.log(error)
                dispatch('notificaciones/showSnack', {
                    message: error.response.data.message,
                    type: (error.response.status).toString(),
                }, { root: true })
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
                dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },
        permitirModTramites({ commit, dispatch, state }, fn) {
            axios({
                method: 'get',
                url: process.env.VUE_APP_API + 'portal/misTramites/' + sessionStorage.getItem('nroafi'),
                withCredentials: false,
            }).then((response) => {
                const res = response.data.misTramites
                commit('setListaTramites', res)
                if (typeof (fn) === 'function')
                    fn()
            }).catch(function (error) {
                console.log(error)
                /*                 
                dispatch('notificaciones/showSnack', {
                    message: error.response.data.message,
                    type: (error.response.status).toString(),
                    }, { root: true })
                */
            })
        },
        async imprimirPdfTramite({ commit, dispatch }, rutadocumento) {
            try {
                // Obtener el token del sessionStorage o localStorage
                const token = sessionStorage.getItem('token') || localStorage.getItem('token');
                const rutaArchivo = encodeURIComponent(window.btoa(rutadocumento));
                // Realizar la petición con axios para obtener el PDF con el token en las cabeceras
                const response = await axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API + 'portal/mostrarArchivo',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`,
                    },
                    data: JSON.stringify({ rutaArchivo }),
                    responseType: 'blob',
                });

                // Crear un blob URL para el PDF
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                const pdfUrl = window.URL.createObjectURL(pdfBlob);

                // Descargar el PDF con el nombre del archivo original
                const nombreArchivo = String(rutadocumento).split('/').pop() || 'documento.pdf';
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.download = nombreArchivo;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Liberar el blob URL cuando la descarga ya tomo el archivo
                setTimeout(() => {
                    window.URL.revokeObjectURL(pdfUrl);
                }, 60000);

            } catch (error) {
                console.error('Error al obtener el PDF:', error);
                dispatch('notificaciones/showSnack', {
                    message: 'Error al abrir el documento. Intente nuevamente.',
                    type: '400'
                }, { root: true });
            }
        },
    },
})